module.exports = __webpack_public_path__ + "img/block_bg_2.8748a859.png";